import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import {RestService} from '../providers/rest.service';
import {ToastrService} from 'ngx-toastr';
import {TalepOnaySeviye} from '../model/talep-onay-seviye';
import {TalepTur} from '../model/talep-tur';
import {KullaniciGrup} from '../model/kullanici-grup';

@Component({
  selector: 'app-talep-onay-seviye-ekle-duzenle',
  templateUrl: './talep-onay-seviye-ekle-duzenle.component.html',
  styleUrls: ['./talep-onay-seviye-ekle-duzenle.component.css']
})
export class TalepOnaySeviyeEkleDuzenleComponent implements OnInit, OnDestroy {

  private subscriptions: Subscription[] = [];
  id: string = null;
  talepOnaySeviye: TalepOnaySeviye = null;
  talepTurler: TalepTur[] = null;
  kullaniciGruplar: KullaniciGrup[] = null;

  constructor(private route: ActivatedRoute,
              private router: Router,
              private restService: RestService,
              private toastrService: ToastrService) {
  }

  ngOnInit(): void {
    this.subscriptions.push(this.route.queryParams.subscribe(params => {
      // console.log(params);
      this.id = params.id;
      if (this.id !== '0') {
        this.getKullanici();
      } else {
        this.talepOnaySeviye = new TalepOnaySeviye();
        this.talepOnaySeviye.seviye = null;
        this.talepOnaySeviye.talepTurId = null;
        this.talepOnaySeviye.kullaniciGrupId = null;
        this.talepOnaySeviyeEkleHazirla();
      }
    }));
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  getKullanici() {
    this.restService.talepOnaySeviye(this.id).subscribe(res => {
      if (res) {
        this.talepOnaySeviye = res;
        this.talepOnaySeviyeEkleHazirla();
      }
    });
  }

  save() {
    const subscription = res => {
      this.toastrService.show('Kaydedildi', 'Başarılı');
      this.router.navigate(['talep-onay-seviyeler']);
    };
    if (this.id === '0') {
      this.restService.talepOnaySeviyeEkle(this.talepOnaySeviye).subscribe(subscription);
    } else {
      this.restService.talepOnaySeviyeDuzenle(this.talepOnaySeviye).subscribe(subscription);
    }
  }

  talepOnaySeviyeEkleHazirla() {
    this.restService.talepTurler().subscribe(res => {
      this.talepTurler = res;
    });
    this.restService.kullaniciGruplar().subscribe(res => {
      this.kullaniciGruplar = res;
    });
  }
}
